import { gql } from "@apollo/client";
import { INTERVIEW_RESPONSE_ANSWER_FIELDS } from "graphql/fragments";

const SUBMIT_INTERVIEW_ANSWER = gql`
  ${INTERVIEW_RESPONSE_ANSWER_FIELDS}
  mutation submitInterviewAnswer($input: SubmitInterviewAnswerInput!) {
    submitInterviewAnswer(input: $input) {
      id
      answers {
        ...InterviewResponseAnswerFields
      }
      profile {
        id
        completedInterviewsCount
      }
    }
  }
`;

export { SUBMIT_INTERVIEW_ANSWER };
